import type { ReactNode } from 'react'
import { cx } from '../lib/util.ts'

export function Bubble({ role, children, failed, tone }: {
  role: 'user' | 'assistant'
  children: ReactNode
  failed?: boolean
  tone?: 'quiet'
}) {
  return (
    <div className={cx('turn', role)}>
      <div className={cx('bubble', role, failed && 'failed', tone)}>{children}</div>
    </div>
  )
}

export function Typing({ label }: { label: string }) {
  return (
    <div className="turn assistant">
      <div className="bubble assistant thinking">
        <span className="spinner" />
        <span>{label}</span>
      </div>
    </div>
  )
}
